import CTAButton from '@/components/shared/CTAButton'

const LenderClaimSteps = ({ lenderName }) => {
  return (
    <section className="py-12 md:py-16">
      <div className="container mx-auto max-w-6xl px-4">
        <h2
          className="mb-4 text-3xl font-bold"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          Start Your {lenderName} Finance Claim in Just 60 Seconds
        </h2>

        <p
          className="mb-12 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          If you were mis-sold {lenderName} car finance, now&apos;s the perfect
          time to take action. Starting your {lenderName} finance claim is
          quick, simple, and completely hassle-free. We could help you claim in
          60 seconds. No win, no fee
          <sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>3</sup>.
        </p>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* Step 1 */}
          <div className="bg-card border-foreground group rounded-lg border-2 p-6 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <div
              className="text-primary mb-2 text-2xl font-bold"
              aria-label="Step 1"
            >
              Step 1
            </div>
            <div
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              We Locate Your Finance Agreements
            </div>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Using trusted credit reference agencies and vehicle records
              enabling us to find all car finance agreements linked to you, even
              if you&apos;ve changed your name or moved home. This includes
              agreements dating back to{' '}
              <span className="font-raleway-numbers">2007</span> which are often
              hard for individuals to trace.
            </p>
          </div>

          {/* Step 2 */}
          <div className="bg-card border-foreground group rounded-lg border-2 p-6 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <div
              className="text-primary mb-2 text-2xl font-bold"
              aria-label="Step 2"
            >
              Step 2
            </div>
            <div
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              We Get Things Moving
            </div>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Once you&apos;ve provided a few simple details, our technology
              goes to work instantly. We search your history and identify any
              past {lenderName} car finance agreements, even those dating back{' '}
              <span className="font-raleway-numbers">2007</span>, which are
              often difficult for individuals to locate.
            </p>
          </div>

          {/* Step 3 */}
          <div className="bg-card border-foreground group rounded-lg border-2 p-6 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <div
              className="text-primary mb-2 text-2xl font-bold"
              aria-label="Step 3"
            >
              Step 3
            </div>
            <div
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              We Build Your Claim
            </div>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Your case is handed to our expert partner law firm. They carefully
              review each agreement, gather supporting evidence, and negotiate
              directly with the lender to maximise your refund. All of this is
              done on a{' '}
              <strong
                className="font-semibold"
                style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
              >
                No win, no fee³
              </strong>
              <sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>3</sup>{' '}
              basis, so you can sit back while we do the hard work.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

export default LenderClaimSteps
